import { Member, PublicTenant } from '@rewardops/env'

export const localeFromLocaleStr = (localeStr: string) => {
  const split = localeStr.split('-')

  return {
    locale: localeStr,
    language: split[0],
    country: split[1],
  }
}

export function getLocaleFromMemberOrTenant(
  member: Member,
  tenant: PublicTenant,
) {
  if (!member) {
    throw new Error('No member found')
  }
  const memberLocale = member.locale ?? ''
  if (tenant.locale.supported.includes(memberLocale)) {
    return memberLocale ?? tenant.locale.default
  }
  return tenant.locale.default
}

export function getCurrentLocale(
  cookies: Partial<{
    [key: string]: string
  }>,
  member: Member,
  tenant: PublicTenant,
) {
  return cookies['NEXT_LOCALE'] || getLocaleFromMemberOrTenant(member, tenant)
}
